import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { clearStorage } from '../services/authService'

export const Logout: React.FC = () => {
    useEffect(() => {
        clearStorage()
    }, [])

    return <Navigate to="/" />
}
